import React, { useState, useEffect } from 'react';
import { useParams, Link as RouterLink, useNavigate } from 'react-router-dom';

import {
  makeStyles,
  Typography,
  Card,
  Box,
  Container,
  Link,
  Button
} from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import CustomerInvoiceForm from 'src/customer-invoice/ui/components/CustomerInvoiceForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  saveButton: {
    top: '-20px'
  },
  backButton: {
    top: '-20px',
    marginRight: theme.spacing(1)
  },
  scrollBox: {
    overflow: 'scroll',
    height: '80vh'
  }
}));

const ContractFormView = () => {
  const classes = useStyles();

  const { invoiceId } = useParams();
  const navigate = useNavigate();

  const onSuccess = () => {
    navigate('/app/billing');
  };

  const onCancel = () => {
    navigate('/app/billing');
  };

  return (
    <Page className={classes.root} title="Factura">
      <Container maxWidth={false}>
        <Box className={classes.navigation} display="flex">
          <Typography color="textSecondary" variant="body2">
            <Link component={RouterLink} to="/app/billing">
              Facturas
            </Link>
          </Typography>
        </Box>
        <Card>
          <CustomerInvoiceForm
            customerInvoiceId={invoiceId}
            success={onSuccess}
            cancel={onCancel}
          />
        </Card>
      </Container>
    </Page>
  );
};

export default ContractFormView;
